import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import defaultsDeep from 'lodash/object/defaultsDeep';
import Highstock from 'highcharts/highstock';

import highchartsOptions from 'utils/highchartsOptions';

import defaultConfig from './config';

const StockChart = createReactClass({
  displayName: 'StockChart',

  getDefaultProps: function() {
    return {
      loading: false,
      breaks: [],
      config: {},
    };
  },

  propTypes: {
    series: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    loading: PropTypes.bool,
  },

  chartInstance: null,

  componentDidMount() {
    this.createChart();
  },

  componentDidUpdate() {
    this.createChart();
  },

  createChart() {
    if (process.env.NODE_ENV === 'test') return;
    if (this.chartInstance) this.chartInstance.destroy();
    Highstock.setOptions(highchartsOptions);
    const ref = this.refs.chart;
    const { series, breaks } = this.props;

    const plotLines = [];
    if (breaks && breaks.length > 0) {
      breaks.forEach(element => {
        plotLines.push({
          value: element.from,
          width: 1,
          color: 'black',
          dashStyle: 'dash',
        });
      });
    }

    const config = (this.config = defaultsDeep(
      {
        chart: { renderTo: ref },
        series: [].concat(series),
        xAxis: { breaks, plotLines },
      },
      this.props.config,
      defaultConfig,
    ));

    this.chartInstance = new Highstock.StockChart(config);
  },

  render() {
    return <div className="highstocks" ref="chart"></div>;
  },
});

export default StockChart;
